// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginTokenForm_form__1fSVs","error-label":"LoginTokenForm_error-label__1Btb0","buttons":"LoginTokenForm_buttons__zUYRM"};